import React from "react";
import "../Css/Gallery.css";

const Error = () => {
  return <div>404 Not Found</div>;
};

export default Error;
